class UnseenNotifications {
    quantity;
    constructor(quantity) {
        this.quantity = quantity;
    }
}
export default UnseenNotifications;
